"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALCULATOR = exports.EXTENDED_MERCH_CARD = exports.MERCH_CARD = void 0;
var MERCH_CARD = 'MERCH_CARD';
exports.MERCH_CARD = MERCH_CARD;
var EXTENDED_MERCH_CARD = 'EXTENDED_MERCH_CARD';
exports.EXTENDED_MERCH_CARD = EXTENDED_MERCH_CARD;
var CALCULATOR = 'CALCULATOR';
exports.CALCULATOR = CALCULATOR;


//////////////////
// WEBPACK FOOTER
// ./js/constants/PurchaseMotionsLocations.js
// module id = 137
// module chunks = 5 6 7